export default {
  "content": "<path d=\"M8.24.912a6.28 6.28 0 00-1.24 0c-3.87.39-6.07 4.68-4.48 8.23l4.11 7.14c.21.4.6.6.99.6s.79-.2 1-.6l4.1-7.14c1.59-3.55-.61-7.84-4.48-8.23zm-.62 7.47c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "17",
    "fill": "currentColor",
    "viewBox": "0 0 16 17"
  }
};